var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_24dp_5F6368_FILL0_wght400_GRAD0_opsz24",
    d: "M115.69-819.41l29.257-29.257-5.81-5.81L115.69-831.03l-11.827-11.828-5.81,5.81ZM121.5-797a40.41,40.41,0,0,1-16.185-3.268,41.909,41.909,0,0,1-13.176-8.871,41.909,41.909,0,0,1-8.871-13.176A40.411,40.411,0,0,1,80-838.5a40.411,40.411,0,0,1,3.268-16.185,41.909,41.909,0,0,1,8.871-13.176,41.909,41.909,0,0,1,13.176-8.871A40.41,40.41,0,0,1,121.5-880a40.411,40.411,0,0,1,16.185,3.268,41.909,41.909,0,0,1,13.176,8.871,41.909,41.909,0,0,1,8.871,13.176A40.411,40.411,0,0,1,163-838.5a40.411,40.411,0,0,1-3.268,16.185,41.909,41.909,0,0,1-8.871,13.176,41.909,41.909,0,0,1-13.176,8.871A40.411,40.411,0,0,1,121.5-797Zm0-8.3a32.042,32.042,0,0,0,23.551-9.649A32.042,32.042,0,0,0,154.7-838.5a32.042,32.042,0,0,0-9.649-23.551A32.042,32.042,0,0,0,121.5-871.7a32.042,32.042,0,0,0-23.551,9.649A32.042,32.042,0,0,0,88.3-838.5a32.042,32.042,0,0,0,9.649,23.551A32.042,32.042,0,0,0,121.5-805.3ZM121.5-838.5Z",
    transform: "translate(-80 880)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPoint);
export default __webpack_public_path__ + "static/media/check-point.10f0e65dc4fb62535e7373e691dd84c0.svg";
export { ForwardRef as ReactComponent };